"use client";

import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";

const approvals = [
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/UGC-768x538.png",
    alt: "Recognition of University Grants Commission (UGC)",
    text: "Recognition of University Grants Commission (UGC)",
    href: "/ugc"
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/NSDC-768x538.png",
    alt: "Approval of National Skill Development Corporation (NSDC)",
    text: "Approval of National Skill Development Corporation (NSDC)",
    href: "https://cdn.msu.edu.in/msu-reavamp/pdf/nsdc_mou.pdf",
    targetBlank: true,
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/NCVET-768x538.png",
    alt: "MSU recognised as an Awarding Body by National Council for Vocational Education and Training (NCVET)",
    text: "MSU recognized as an Awarding Body by National Council for Vocational Education and Training (NCVET)",
    href: "https://ncvet.gov.in/awarding-bodies-3/",
    targetBlank: true,
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/Sikkim-Act-768x538.png",
    alt: "Medhavi Skills University, Sikkim Act 2021",
    text: "Medhavi Skills University, Sikkim Act 2021",
    href: "https://cdn.msu.edu.in/msu-reavamp/pdf/MSU-SIKKIM-ACT-2021.pdf",
    targetBlank: true,
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/DGT-768x538.png",
    alt: "Approval of Directorate General of Training (DGT)",
    text: "Approval of Directorate General of Training (DGT)",
    href: "https://dgt.gov.in/hi/flexi-mou-s",
    targetBlank: true,
  },
  // {
  //   img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/Indian-Air-force-logo-768x538.png",
  //   alt: "MSU and Indian Airforce signs MoU to provide Higher Education for IAF fraternity",
  //   text: "MSU and Indian Airforce signs MoU to provide Higher Education for IAF fraternity",
  //   href: null,
  //   targetBlank: false,
  // },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/AIU-Logo-768x538.png",
    alt: "Association of Indian Universities",
    text: "Association of Indian Universities",
    href: "https://cdn.msu.edu.in/msu-reavamp/pdf/Membershi_at_AIU.pdf",
    targetBlank: true,
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/NSDC-internationl-1-768x538.png",
    alt: "MSU as Project Management Unit (PMU) of NSDC International",
    text: "MSU as Project Management Unit (PMU) of NSDC International",
    href: "https://cdn.msu.edu.in/msu-reavamp/pdf/MSU-PMU-of-NSDC-International.pdf",
    targetBlank: true,
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/ISO-9001-768x538.png",
    alt: "ISO 9001:2015 Certification",
    text: "ISO 9001:2015 Certification",
    href: "https://cdn.msu.edu.in/msu-reavamp/pdf/msu_iso_9001-2015_egac_final_copy.pdf",
    targetBlank: true,
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/ISO-9001-768x538.png",
    alt: "ISO 21001:2018 Certification",
    text: "ISO 21001:2018 Certification",
    href: null,
    targetBlank: false,
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/NAPS-logo-1-768x538.png",
    alt: "Empanelment as Third Party Aggregator (TPA) for National Apprenticeship Promotion Scheme (NAPS)",
    text: "Empanelment as Third Party Aggregator (TPA) for National Apprenticeship Promotion Scheme (NAPS)",
    href: "https://cdn.msu.edu.in/pdf/NAPS_Empanelment_Confirmation_July%202021.pdf",
    targetBlank: true,
  },
  {
    img: "https://cdn.msu.edu.in/msu-reavamp/Award+%26+Recognitions/TTAADC-768x538.png",
    alt: "MSU as Technical Agency of Tripura Tribal Areas Autonomous District Council (TTAADC)",
    text: "MSU as Technical Agency of Tripura Tribal Areas Autonomous District Council (TTAADC)",
    href: "https://cdn.msu.edu.in/msu-reavamp/pdf/TTAADC_MSU_Technica_Agency.pdf",
    targetBlank: true,
  },
  {
    img: "https://cdn.msu.edu.in/website-images/300x200-1_hvlu10.png",
    alt: "Approval of Pharmacy Council of India",
    text: "Approval of Pharmacy Council of India",
    // href: "https://cdn.msu.edu.in/msu-reavamp/pdf/Decision_Letter_Approved_PCI.pdf",
    href:"https://cdn.msu.edu.in/msu-pdf-files/PCI-Decission.pdf",
    targetBlank: true,
  },
  // {
  //   img: "https://cdn.msu.edu.in/logos/PMCI3.jpg",
  //   alt: "Paramedical Council of India",
  //   text: "Paramedical Council of India",
  //   href: null,
  //   targetBlank: false,
  // },
   {
    img: "https://cdn.msu.edu.in/msu-reavamp/images/Recognitions_logo/ncahplogo.png",
    alt: "National Council for Allied healthcare Professionals",
    text: "National Council for Allied healthcare Professionals",
    href: null,
    targetBlank: false,
  },
  {
    img: "https://cdn.msu.edu.in/logos/SNC3.jpg",
    alt: "Sikkim Nursing Council, Gangtok, Sikkim",
    text: "Sikkim Nursing Council, Gangtok, Sikkim",
    href: null,
    targetBlank: false,
  },
];


const ApprovalsGrid = () => {
  return (
    <section className="w-full bg-white">
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {approvals.map((item, idx) => {
            const Wrapper = ({ children }) =>
              item.href ? (
                <a
                  href={item.href}
                  target={item.targetBlank ? "_blank" : undefined}
                  rel={item.targetBlank ? "noopener noreferrer" : undefined}
                  className="block h-full"
                >
                  {children}
                </a>
              ) : (
                <div className="h-full">{children}</div>
              );

            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{
                  duration: 0.6,
                  delay: idx * 0.05,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="group"
              >
                <Wrapper>
                  <div
                    className="relative h-full flex flex-col items-start justify-start
                               border border-gray-200/60 bg-white px-6 py-6 text-left
                               transition-all duration-500 hover:-translate-y-1 hover:border-orange-200 hover:shadow-xl"
                  >
                    <div className="absolute top-10 right-10 h-24 w-24 sm:h-28 sm:w-28 md:h-32 md:w-32 rounded-full bg-gradient-to-br from-orange-200 to-amber-200 opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-60" />

                    <div className="relative flex flex-col gap-4 m-auto">
                      <div className="flex items-center justify-center h-24 w-24 sm:h-28 sm:w-28 rounded-full bg-white border border-gray-200 overflow-hidden m-auto">
                        <Image
                          src={item.img}
                          alt={item.alt}
                          width={100}
                          height={100}
                          className="object-contain"
                          unoptimized
                        />
                      </div>

                      <p
                        className="text-sm sm:text-[15px] leading-snug text-gray-800 m-auto text-center"
                        style={{ fontFamily: "saans-regular" }}
                      >
                        {item.text}
                      </p>
                    </div>

                    <div className="absolute bottom-0 left-0 right-0 h-0.5 sm:h-1 origin-left scale-x-0 rounded-full bg-gradient-to-r from-[#FC9D00] to-[#FF8800] transition-transform duration-500 group-hover:scale-x-100" />
                  </div>
                </Wrapper>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ApprovalsGrid;
